const LoginError = () => {
    return(
        <div className="tds-container">
            <p style={{ textAlign: 'center' }}>You do not have permission to access this application. Please submit a Sailpoint request to obtain access.</p>
        </div>
    );
}
export default LoginError;